import { AppLayout } from "@bcc/components/app-layout";
import { InventoryView } from "@bcc/components/views/inventory-view";

export function InventoryPage() {
  const statsData = [
    {
      name: "Total Items",
      value: "8,234",
      icon: "box",
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
    },
    {
      name: "In Stock",
      value: "7,451",
      icon: "check-circle",
      iconBg: "bg-green-100",
      iconColor: "text-green-600",
    },
    {
      name: "Low Stock",
      value: "623",
      icon: "alert-circle",
      iconBg: "bg-yellow-100",
      iconColor: "text-yellow-600",
    },
    {
      name: "Out of Stock",
      value: "160",
      icon: "x-circle",
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
    },
  ];

  const inventoryData = [
    {
      id: 1,
      product: "Premium Coffee Blend",
      sku: "PCB-001",
      current: 450,
      minimum: 100,
      maximum: 1000,
      location: "Warehouse A",
      status: "in-stock" as const,
    },
    {
      id: 2,
      product: "Single Origin Ethiopia",
      sku: "SOE-002",
      current: 75,
      minimum: 50,
      maximum: 500,
      location: "Warehouse B",
      status: "low-stock" as const,
    },
    {
      id: 3,
      product: "French Roast Beans",
      sku: "FRB-003",
      current: 820,
      minimum: 200,
      maximum: 1500,
      location: "Warehouse A",
      status: "in-stock" as const,
    },
    {
      id: 4,
      product: "Light Roast Sampler",
      sku: "LRS-004",
      current: 0,
      minimum: 100,
      maximum: 800,
      location: "Warehouse C",
      status: "out-of-stock" as const,
    },
    {
      id: 5,
      product: "Espresso Dark Roast",
      sku: "EDR-005",
      current: 290,
      minimum: 150,
      maximum: 600,
      location: "Warehouse B",
      status: "in-stock" as const,
    },
  ];

  return (
    <AppLayout>
      <InventoryView statsData={statsData} inventoryData={inventoryData} />
    </AppLayout>
  );
}
